import { render, staticRenderFns } from "./formItemDataList.vue?vue&type=template&id=f7630f16&scoped=true"
import script from "./formItemDataList.vue?vue&type=script&lang=js"
export * from "./formItemDataList.vue?vue&type=script&lang=js"
import style0 from "./formItemDataList.vue?vue&type=style&index=0&id=f7630f16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7630f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7630f16')) {
      api.createRecord('f7630f16', component.options)
    } else {
      api.reload('f7630f16', component.options)
    }
    module.hot.accept("./formItemDataList.vue?vue&type=template&id=f7630f16&scoped=true", function () {
      api.rerender('f7630f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/formItemDataList.vue"
export default component.exports